import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-100 border-t border-gray-200">
      <div className="max-w-6xl mx-auto px-4 py-4">
        <div className="flex items-center justify-center text-sm text-gray-600">
          <span>All Rights Reserved © Laikos 2026</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
